/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, toConsumableArray as _toConsumableArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import { match } from '../../../../Utilities/keyboard/match.js';
import { ArrowDown, ArrowUp } from '../../../../Utilities/keyboard/keys.js';

var _excluded = ["children"];

/* eslint-disable react/prop-types */

/*
 * Higer Order Component that wraps TableToolbarMenu,
 * returning a new component with keyboard navigation menu focus support
 * Note: For menu focus to work, each item to receive focus must include the "data-table-settings-item-focusable" attribute
 *       Refer to TableSettings/TableSettingsColumns and TableSettings/TableSettingsSize for examples.
 */
var withMenuFocus = function withMenuFocus(WrappedToolbarMenu) {
  return function (_ref) {
    var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocus = _useState2[1];
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    var updateMenuFocus = function updateMenuFocus(fromOnOpen) {
      var nodes = _toConsumableArray(document.querySelectorAll('[data-table-settings-item-focusable]'));
      if (nodes && focused >= 0 && nodes[focused]) {
        var _nodes$focused;
        var defaultSelected = nodes[focused];
        if (fromOnOpen && ((_nodes$focused = nodes[focused]) === null || _nodes$focused === void 0 ? void 0 : _nodes$focused.type) === 'radio') {
          defaultSelected = nodes.find(function (node) {
            return node.checked;
          });
        }
        defaultSelected.focus();
      }
    };
    useEffect(function () {
      updateMenuFocus();
    });
    var handleMenuItemFocus = function handleMenuItemFocus(evt) {
      var nodes = _toConsumableArray(document.querySelectorAll('[data-table-settings-item-focusable]'));
      var len = nodes.length;
      if (len > 0 && match(evt, ArrowDown)) {
        setFocus((focused + 1) % len);
      } else if (len > 0 && match(evt, ArrowUp)) {
        setFocus((focused - 1 + len) % len);
      }
    };
    var childrenWithProps = React.Children.toArray(children).map(function (child) {
      return /*#__PURE__*/React.cloneElement(child, {
        handleMenuItemFocus: handleMenuItemFocus
      });
    });
    return /*#__PURE__*/React.createElement(WrappedToolbarMenu
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, props, {
      onOpen: function onOpen() {
        return updateMenuFocus(true);
      },
      menuOptionsClass: "cds--table-settings-menu__body",
      iconDescription: t('Settings')
    }), childrenWithProps);
  };
};
var withMenuFocus$1 = withMenuFocus;

export { withMenuFocus$1 as default };
